import * as React from 'react';
import { Avatar, Popover } from 'antd';
import { getInitial } from '../../utils/DataFormatterUtils';

export const EmailUserName = ({ email, placement = 'left' }) => {
	return email ? (
		<Popover content={<div>{email}</div>} placement={placement}>
			<Avatar>{getInitial(email).toUpperCase()}</Avatar>
		</Popover>
	) : null;
};
